<template>
  <div>
    <v-form>
      <v-container>
        <span class="headline">Save Motor Performance Data</span>
        <v-row>
          <v-col v-if="false" cols="12" lg="2" md="3" sm="4">
            <v-select v-model="perf.motorid"
             :items="motors" label="Motor">

             </v-select>

            
          </v-col>

             <v-col v-if="false" cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="perf.frequency" suffix="Hz" label="Frequency"
           required></v-text-field>
        </v-col>

          <v-col cols="12" md="9">
            <v-textarea
              v-model="performance_data"
              label="Performance Datas"
              hint="Excell tablosunu kopyalayıp yapıştırınız."
            ></v-textarea>
          </v-col>

          <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.material" label="Material" required></v-text-field>
          </v-col>-->
        </v-row>

        <div class="my-2">
          <v-col cols="12" md="6">
            <v-btn class="ma-2" @click="parseData" color="primary">Save</v-btn>

            <v-btn class="ma-2" @click="goBack" color="secondary">Cancel</v-btn>

          </v-col>
           
        </div>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "MotorPerformanceAdd",
  data: () => ({
    token: "",
    performance_data: "",
    perf: {
      motorid: -1,
      frequency: "",
      loads: [],
      sampleLoad: {
        rate: 50,
        effiency: 40,
        cos_fi: 0.78,
        In: 10,
        rpm: 2000,
        voltage: 380
      },
    },
    motors: []
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchMotors();
  },
  methods: {
    goBack : function() {
      window.history.go(-1)
    },
    savePerformanceData: function() {
 
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_motor_performance_data",
        data: this.perf.loads
      })
        .then(response => {
          console.log(response.data);
          if (response.data == "1"){
           this.performance_data = ""
           this.perf.motorid = -1
          } 
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    
    fetchMotors: function() {
      this.motors = [];
      this.$http.get(this.$API_URL + "motors").then(result => {
        result.data.forEach(motor => {
          this.motors.push({
            text: motor.type +" " + motor.power +" HP, "
            +motor.axial_load_capacity +" kN, "+motor.phase+" Phase",
            value: motor.idmotor
          });
        });
      });
    },
    parseData: function() {
      //       sampleLoad: {
      //   rate: 50,
      //   effiency: 40,
      //   cos_fi: 0.78,
      //   In: 10,
      //   rpm: 2000,
      //   voltage: 380
      // },

      // clear datas.
      this.perf.loads = [];

      var dataLines = this.performance_data
        .replace(/\t/g, " ")
        .replace(/,/g, ".")
        .split("XSM")
        // .split("\n");
      
      dataLines.forEach(tempLine => {
          if (tempLine != ""){
            
            var temp2Line = tempLine.split("Hz")
            // console.log(temp2Line)
            var motorSpecs = temp2Line[0].trim().split(" ")
            var values = temp2Line[1].trim().split("\n")
            
            var values1 = values[0].trim().split(" ")
            var values2 = values[1].trim().split(" ")
            
            if  (values[2] != null)
              var values3 = values[2].trim().split(" ")
            else
            var values3 = []
            
            // motorSpecs[0] = motorSpecs[0].replace("\"","")

            this.perf.loads.push(
              {
                motorType: "XSM "+motorSpecs[0],
                motorPower: motorSpecs[1],
                axial_load_capacity: motorSpecs[3],
                frequency: motorSpecs[4],
                voltage: [values1[0], values2[0], values3[0]],
                rpm: [values1[1], values2[1], values3[1]],
                I_n: [values1[2], values2[2], values3[2]],
                eff50: [values1[3], values2[3], values3[3]],
                eff75: [values1[4], values2[4], values3[4]],
                eff100: [values1[5], values2[5], values3[5]],
                cos_fi50: [values1[6], values2[6], values3[6]],
                cos_fi75: [values1[7], values2[7], values3[7]],
                cos_fi100: [values1[8], values2[8], values3[8]],
              }
            )

            // console.log(motorSpecs)
            // console.log(values1)
            // console.log(values2)
            // console.log(values3)
             

          }
      })

      // console.log(this.perf.loads)

      // return


      // console.log(dataLines);

       
//   dataLines.forEach(line => {
//     if (line != ""){
//         var firtLines = line.split("Hz")
//         var values = firtLines[1].split("\n")

//         console.log(values)

//     }

     
// })



//       return
 
  // dataLines.forEach(line => {

  //     var values = line.split(" ")

  //     this.perf.loads.push(
  //       {
  //         voltage: values[0],
  //         rpm: values[1],
  //         I_n: values[2],
  //         eff50: values[3],
  //         eff75: values[4],
  //         eff100: values[5],
  //         cos_fi50: values[6],
  //         cos_fi75: values[7],
  //         cos_fi100: values[8],
  //       }
  //     )

  // })
  
      console.log(this.perf.loads);
      this.savePerformanceData();
      // console.log(this.perf.hm);
    }
  }
};
</script>
